import { PRISMIC_FETCH, PRISMIC_FETCH_SUCCESS } from '../actions/prismic-actions';

const initialState = {};

function prismicReducer(state = initialState, action) {
    switch (action.type) {
        case PRISMIC_FETCH: {
            const { uid } = action.payload;
            return {
                ...state,
                [uid]: {
                    loading: true,
                },
            };
        }

        case PRISMIC_FETCH_SUCCESS: {
            const { uid, data } = action.payload;
            return {
                ...state,
                [uid]: data.contentSlices,
            };
        }

        default: {
            return state;
        }
    }
}

export default prismicReducer;
